import { UserRequestSteps } from "../requests/Requests.tsx";

const requestStepsWithoutDelete = UserRequestSteps.slice(0, -1);
export const homeSteps = [
  {
    target: ".j_h_dash",
    content:
      "This is your Dashboard. It gives a quick overview of user requests and their current statuses.",
    placement: "right",
  },
  {
    target: ".j_h_req",
    content:
      "Access all Requests here — track, manage, and review user submissions.",
    placement: "right",
  },
  {
    target: ".j_h_users",
    content:
      "Manage all application Users from this section — add, edit, or review their details.",
    placement: "right",
  },
  {
    target: ".j_h_roles",
    content:
      "View and configure Roles that define user permissions and access levels.",
    placement: "right",
  },
  {
    target: ".j_h_rGrp",
    content:
      "Use Security Groups to organize users under role-based access policies.",
    placement: "right",
  },
  {
    target: ".j_h_analytics",
    content:
      "Manage Report Distribution — who receives what reports and how often.",
    placement: "right",
  },
  {
    target: ".j_h_settings",
    content:
      "Configure Application Settings including preferences, integrations, and more.",
    placement: "right",
  },
    {
    target: ".j_h_uInfo",
    content:
      "This section displays details about the currently logged-in user including name, role, and email.",
    placement: "left",
  },

  // Additional request section steps
  ...requestStepsWithoutDelete,

  {
    target: ".j_h_theme",
    content: "Toggle between Light and Dark mode for your preferred theme.",
    placement: "left",
  },
  {
    target: ".j_h_lgout",
    content: "Click here to Logout and securely end your session.",
    placement: "left",
  },

];